import { useMutation } from 'react-query';
import wallet from 'services/api/wallet';
import useTranslation from 'utils/hooks/useTranslation';
import notify from 'utils/notificationUtils';
import useAmplitude from 'utils/hooks/useAmplitude';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';

export const useFreezeWallet = () => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();

  return useMutation({
    mutationFn: async () => {
      const result = await wallet.freeze();
      return result?.data;
    },
    onSuccess: () => {
      notify({
        type: 'success',
        message: translateText('corporateAccounts.wallet.dashboard.footer.freeze.success'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletFreezeSuccessful);
    },
    onError: () => {
      notify({
        type: 'error',
        message: translateText('corporateAccounts.wallet.dashboard.footer.freeze.error'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletFreezeFailed);
    },
  });
};

export const useCloseWallet = () => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();

  return useMutation({
    mutationFn: async note => {
      const result = await wallet.close(note);
      return result?.data;
    },
    onSuccess: () => {
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletCloseSuccessful);
    },
    onError: () => {
      notify({
        type: 'error',
        message: translateText('corporateAccounts.wallet.dashboard.footer.close.error'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletCloseFailed);
    },
  });
};

export default { useFreezeWallet, useCloseWallet };
